(function () {
  'use strict';
  if (window.__axInit) return;
  window.__axInit = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    var n = cents / 100;
    return '$' + (cents % 100 ? n.toFixed(2) : String(Math.round(n)));
  }

  /* Adds items through the same flow as Impact's product-form, so the cart drawer,
     cart count and free-shipping bar all update and the drawer opens. */
  async function addToCart(items, source) {
    var sections = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: root + 'variants/' + items[0].id })
    });
    var json = await res.json();
    if (!res.ok) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      throw new Error(json.description || 'Could not add to cart');
    }
    var cart = await (await fetch(root + 'cart.js')).json();
    cart.sections = json.sections;
    source.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items || [json], cart: cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
  }

  /* ---------------- header ---------------- */
  function initHeader() {
    var header = $('[data-ax-header]');
    if (!header) return;
    if (header.hasAttribute('data-overlay')) {
      var hero = $('.ax-hero');
      var onScroll = function () {
        var limit = hero ? hero.offsetHeight - 110 : 40;
        header.classList.toggle('is-solid', window.scrollY > limit);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    $$('.ax-nav__item', header).forEach(function (it) {
      var b = $('.ax-nav__top', it);
      b.addEventListener('click', function () {
        var open = !it.classList.contains('is-open');
        $$('.ax-nav__item.is-open', header).forEach(function (o) { o.classList.remove('is-open'); $('.ax-nav__top', o).setAttribute('aria-expanded', 'false'); });
        it.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', open);
      });
      it.addEventListener('focusout', function (e) {
        if (!it.contains(e.relatedTarget)) { it.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('.ax-nav__item.is-open', header).forEach(function (o) { o.classList.remove('is-open'); $('.ax-nav__top', o).setAttribute('aria-expanded', 'false'); });
      closeMnav();
    });

    var mnav = $('#ax-mnav'), burger = $('.ax-header__burger', header);
    function closeMnav() {
      if (!mnav || mnav.hidden) return;
      mnav.hidden = true;
      document.documentElement.style.overflow = '';
      burger.setAttribute('aria-expanded', 'false');
      burger.focus();
    }
    if (mnav && burger) {
      burger.addEventListener('click', function () {
        mnav.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        burger.setAttribute('aria-expanded', 'true');
        var first = $('button, a', mnav);
        if (first) first.focus();
      });
      mnav.addEventListener('click', function (e) {
        if (e.target.closest('[data-ax-mnav-close]') || e.target.closest('a')) closeMnav();
      });
    }
  }

  /* ---------------- reveal ---------------- */
  function initReveal() {
    var els = $$('.ax-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- flagship variant picker ---------------- */
  function initFlagship(sec) {
    var data = $('[data-ax-variants]', sec);
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var form = $('form', sec);
    var sel = $$('[data-ax-opt-label]', sec).map(function (el) { return el.textContent.trim(); });

    function availFor(i, val) {
      return variants.some(function (v) {
        return v.available && v.options[i] === val && v.options.every(function (x, j) { return j >= i || x === sel[j]; });
      });
    }
    function update() {
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      if (!v) {
        v = variants.filter(function (x) { return x.options[0] === sel[0] && x.available; })[0] || variants.filter(function (x) { return x.options[0] === sel[0]; })[0] || variants[0];
        sel = v.options.slice();
      }
      $('[data-ax-vid]', sec).value = v.id;
      $('[data-ax-price]', sec).textContent = v.price;
      var was = $('[data-ax-was]', sec);
      was.hidden = !v.compare;
      was.textContent = v.compare || '';
      var stock = $('[data-ax-stock]', sec);
      stock.classList.toggle('is-out', !v.available);
      $('span', stock).textContent = v.available ? 'In stock, dispatched in 1–3 business days' : 'Sold out';
      var atc = $('[data-ax-atc]', sec);
      atc.disabled = !v.available;
      atc.textContent = v.available ? 'Add to cart' : 'Sold out';
      $$('[data-ax-opt]', sec).forEach(function (b) {
        var i = +b.dataset.axOpt;
        b.setAttribute('aria-pressed', sel[i] === b.dataset.value);
        b.classList.toggle('is-out', !availFor(i, b.dataset.value));
      });
      $$('[data-ax-opt-label]', sec).forEach(function (el) { el.textContent = sel[+el.dataset.axOptLabel]; });
    }
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ax-opt]');
      if (!b) return;
      sel[+b.dataset.axOpt] = b.dataset.value;
      update();
    });
    if (form) update();
  }

  /* ---------------- product finder ---------------- */
  function initFinder(sec) {
    var src = $('[data-ax-products]', sec);
    if (!src) return;
    var items = JSON.parse(src.textContent);
    var entry = +sec.dataset.entry, flag = +sec.dataset.flag;
    var F = { budget: 'all', brand: '', guide: '', sort: 'rec', stock: true };
    var interline = function (p) { return /interline|\bIL\b/i.test(p.title); };

    var brandSel = $('[data-f="brand"]', sec), brands = [];
    items.forEach(function (p) { if (p.vendor && brands.indexOf(p.vendor) < 0) brands.push(p.vendor); });
    brandSel.insertAdjacentHTML('beforeend', brands.sort().map(function (b) { return '<option>' + esc(b) + '</option>'; }).join(''));

    function render() {
      var list = items.filter(function (p) {
        if (F.budget === 'entry' && p.min >= entry) return false;
        if (F.budget === 'mid' && (p.min < entry || p.min >= flag)) return false;
        if (F.budget === 'flag' && p.min < flag) return false;
        if (F.brand && p.vendor !== F.brand) return false;
        if (F.guide === 'il' && !interline(p)) return false;
        if (F.guide === 'out' && interline(p)) return false;
        if (F.stock && !p.avail) return false;
        return true;
      });
      if (F.sort !== 'rec') list = list.slice().sort(function (a, b) { return F.sort === 'asc' ? a.min - b.min : b.min - a.min; });
      var hidden = F.stock ? items.filter(function (p) { return !p.avail; }).length : 0;
      $('[data-ax-count]', sec).textContent = list.length + (list.length === 1 ? ' product' : ' products') + (hidden ? ' · ' + hidden + ' sold out hidden' : '');
      var grid = $('[data-ax-grid]', sec);
      if (!list.length) {
        grid.innerHTML = '<p class="ax-empty">Nothing matches those filters. <button type="button" class="ax-btn ax-btn--ghost" data-ax-reset>Clear filters</button></p>';
        return;
      }
      grid.innerHTML = list.map(function (p) {
        var tag = !p.avail ? 'Sold out' : interline(p) ? 'Interline' : '';
        return '<article class="ax-card' + (p.avail ? '' : ' is-out') + '">' +
          '<a href="' + p.url + '" class="ax-card__img" tabindex="-1" aria-hidden="true">' +
          (p.img ? '<img src="' + p.img + '" alt="" loading="lazy"' + (p.ratio > 4 ? ' class="is-flat"' : '') + '>' : '') +
          (tag ? '<span class="ax-card__tag">' + tag + '</span>' : '') + '</a>' +
          '<p class="ax-card__brand">' + esc(p.vendor) + '</p>' +
          '<h3 class="ax-card__name"><a href="' + p.url + '">' + esc(p.title) + '</a></h3>' +
          '<p class="ax-card__meta"><span>' + (p.n > 1 ? p.n + ' models' : '') + '</span><span>' + (p.max > p.min ? 'From ' : '') + p.minf + '</span></p></article>';
      }).join('');
    }

    var seg = $('[data-f="budget"]', sec);
    seg.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      $$('button', seg).forEach(function (x) { x.setAttribute('aria-checked', x === b); });
      F.budget = b.dataset.v;
      render();
    });
    seg.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var bs = $$('button', seg), i = bs.indexOf(document.activeElement);
      var n = bs[(i + (e.key === 'ArrowRight' ? 1 : bs.length - 1)) % bs.length];
      n.focus(); n.click();
    });
    ['brand', 'guide', 'sort'].forEach(function (k) {
      var el = $('[data-f="' + k + '"]', sec);
      if (el) el.addEventListener('change', function () { F[k] = el.value; render(); });
    });
    $('[data-f="stock"]', sec).addEventListener('change', function (e) { F.stock = e.target.checked; render(); });
    sec.addEventListener('click', function (e) {
      if (!e.target.closest('[data-ax-reset]')) return;
      F = { budget: 'all', brand: '', guide: '', sort: 'rec', stock: true };
      $$('button', seg).forEach(function (x) { x.setAttribute('aria-checked', x.dataset.v === 'all'); });
      $$('select', sec).forEach(function (s) { s.selectedIndex = 0; });
      $('[data-f="stock"]', sec).checked = true;
      render();
    });
    render();
  }

  /* ---------------- jig box ---------------- */
  function initBox(sec) {
    var btn = $('[data-ax-box-add]', sec), msg = $('[data-ax-box-msg]', sec);
    function total() {
      var n = 0, sum = 0;
      $$('[data-ax-pick]', sec).forEach(function (c) {
        c.closest('.ax-slot').classList.toggle('is-off', !c.checked);
        if (c.checked) { n++; sum += +c.dataset.price; }
      });
      $('[data-ax-box-count]', sec).textContent = n + (n === 1 ? ' jig' : ' jigs');
      $('[data-ax-box-sum]', sec).textContent = money(sum);
      btn.disabled = !n;
    }
    sec.addEventListener('change', total);
    btn.addEventListener('click', async function () {
      var items = $$('[data-ax-pick]:checked', sec).map(function (c) { return { id: +c.value, quantity: 1 }; });
      if (!items.length) return;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      msg.textContent = '';
      try {
        await addToCart(items, btn);
      } catch (err) {
        msg.textContent = err.message;
      }
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    });
    total();
  }

  /* ---------------- squid forecast ---------------- */
  function initSquid(box) {
    var SF = window.SquidForecast;
    if (!SF) return;
    var cache = {};
    var sel = $('[data-sq-spot]', box), v = $('.ax-squid__verdict', box), geo = $('[data-sq-geo]', box);
    /* Shared with the squid-bite-forecast section so both remember the same spot. */
    var STORE_KEY = 'sqf.spot.v1';
    var STATES = { VIC: 'Victoria', NSW: 'New South Wales', SA: 'South Australia', TAS: 'Tasmania', WA: 'Western Australia', QLD: 'Queensland', NT: 'Northern Territory' };
    var spots = [];
    try { spots = JSON.parse($('[data-sq-spots]', box).textContent); } catch (e) {}
    var groups = {};
    spots.forEach(function (s, i) {
      if (!groups[s.s]) {
        groups[s.s] = document.createElement('optgroup');
        groups[s.s].label = STATES[s.s] || s.s;
        sel.appendChild(groups[s.s]);
      }
      var o = document.createElement('option');
      o.value = String(i);
      o.textContent = s.n;
      groups[s.s].appendChild(o);
    });
    function remember(s) { try { localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {} }
    function indexOf(name) { for (var i = 0; i < spots.length; i++) if (spots[i].n === name) return i; return -1; }
    function km(a, b, c, d) {
      var r = Math.PI / 180, x = Math.sin((c - a) * r / 2), y = Math.sin((d - b) * r / 2);
      return 12742 * Math.asin(Math.sqrt(x * x + Math.cos(a * r) * Math.cos(c * r) * y * y));
    }
    function hhmm(iso) { var d = new Date(iso), m = d.getMinutes(); return (d.getHours() % 12 || 12) + ':' + (m < 10 ? '0' : '') + m; }
    function locate(quiet) {
      if (!navigator.geolocation) { if (!quiet) geo.textContent = 'Location unavailable'; return; }
      if (!quiet) geo.textContent = 'Locating…';
      navigator.geolocation.getCurrentPosition(function (pos) {
        var best = -1, bd = Infinity;
        spots.forEach(function (s, i) {
          var d = km(pos.coords.latitude, pos.coords.longitude, s.lat, s.lon);
          if (d < bd) { bd = d; best = i; }
        });
        if (best < 0) { geo.textContent = 'Near me'; return; }
        sel.value = String(best);
        remember(spots[best]);
        geo.textContent = (bd < 10 ? bd.toFixed(1) : Math.round(bd)) + ' km away';
        load();
      }, function () {
        if (!quiet) geo.textContent = 'Location declined';
      }, { timeout: 8000, maximumAge: 600000 });
    }
    function load() {
      var s = spots[+sel.value];
      if (!s) return;
      var ll = [s.lat, s.lon];
      $('[data-sq-word]', box).textContent = 'Loading';
      $('[data-sq-score]', box).textContent = '';
      v.removeAttribute('data-k');
      (cache[sel.value] || (cache[sel.value] = SF.fetchAll(+ll[0], +ll[1]))).then(function (data) {
        var d = SF.scoreDay(data, SF.todayIndex(data.fc), { species: SF.SPECIES.southern, usesLight: false });
        v.setAttribute('data-k', d.verdict.key);
        $('[data-sq-word]', box).textContent = d.verdict.label;
        $('[data-sq-score]', box).textContent = d.total + ' / 12';
        $('[data-sq-data]', box).textContent = 'Dusk ' + hhmm(d.duskStart) + '–' + hhmm(d.duskEnd) + 'pm' +
          (d.sst != null ? ' · Water ' + d.sst.toFixed(1) + '°C' : '') +
          (d.wind != null ? ' · Wind ' + Math.round(d.wind) + ' kn' : '');
      }).catch(function () {
        delete cache[sel.value];
        $('[data-sq-word]', box).textContent = 'Unavailable';
        $('[data-sq-data]', box).textContent = 'Couldn\'t reach the forecast. Try again shortly.';
      });
    }
    sel.addEventListener('change', function () {
      geo.textContent = 'Near me';
      remember(spots[+sel.value]);
      load();
    });
    geo.addEventListener('click', function () { locate(false); });

    var start = -1, saved = null;
    try { saved = JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) {}
    if (saved && saved.n) start = indexOf(saved.n);
    if (start < 0) start = indexOf('Rye / Blairgowrie');
    sel.value = String(Math.max(start, 0));
    load();
    /* Only auto-locate when permission was granted earlier, so first-time visitors never get a prompt on load. */
    if (!saved && navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'geolocation' }).then(function (p) { if (p.state === 'granted') locate(true); }).catch(function () {});
    }
  }

  /* Long horizontal rod shots leave a square frame mostly empty; tilt them diagonally. */
  function initTilt() {
    $$('[id^="lx-pdp-"] .lx-tile img').forEach(function (im) {
      var check = function () { im.classList.toggle('ax-flat', im.naturalWidth / im.naturalHeight > 4); };
      im.addEventListener('load', check);
      if (im.complete && im.naturalWidth) check();
    });
  }

  function boot() {
    initHeader();
    initTilt();
    initReveal();
    $$('[data-ax-flag]').forEach(initFlagship);
    $$('[data-ax-finder]').forEach(initFinder);
    $$('[data-ax-box]').forEach(initBox);
    var sq = $('[data-ax-squid]');
    if (sq) {
      if (window.SquidForecast) initSquid(sq);
      else window.addEventListener('load', function () { initSquid(sq); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Theme editor: re-run when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal();
    $$('[data-ax-flag]', e.target).forEach(initFlagship);
    $$('[data-ax-finder]', e.target).forEach(initFinder);
    $$('[data-ax-box]', e.target).forEach(initBox);
    var sq = $('[data-ax-squid]', e.target);
    if (sq && window.SquidForecast) initSquid(sq);
  });
})();
